var map = {
	"./1893/title_uk.svg": "d716",
	"./1925/title_uk.svg": "0790",
	"./1949/title_uk.svg": "55a9",
	"./1951/title_uk.svg": "8ca4",
	"./1956/title_uk.svg": "2ddb",
	"./1960/title_uk.svg": "b2d8",
	"./1982/title_uk.svg": "ca23",
	"./1993/title_uk.svg": "5cd6",
	"./2016/title_uk.svg": "492e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ced";